// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    QACCustomHeader,
    QACCustomHeaderFromJSON,
    QACCustomHeaderToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrainingSessionPayload
 */
export interface TrainingSessionPayload {
    /**
     * Test case ID associated with the session
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    testcase: number;
    /**
     * Specific revision ID that triggered the session
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    testcaserevision?: number;
    /**
     * Base URL that was used while replaying the flow
     * @type {string}
     * @memberof TrainingSessionPayload
     */
    trainingUrl?: string;
    /**
     * Optional headers that should be injected during the training run
     * @type {Array<QACCustomHeader>}
     * @memberof TrainingSessionPayload
     */
    customHeaders?: Array<QACCustomHeader>;
    /**
     * ID of the user who initiated the training
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    triggeredBy?: number;
    /**
     * Total time spent in seconds
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    timeTaken?: number;
    /**
     * Total number of tokens consumed
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    tokensConsumed?: number;
    /**
     * Final result for the session. Omit for in-progress runs
     * @type {string}
     * @memberof TrainingSessionPayload
     */
    result?: TrainingSessionPayloadResultEnum;
    /**
     * Current state for the session. Defaults to queued for new runs
     * @type {string}
     * @memberof TrainingSessionPayload
     */
    status?: TrainingSessionPayloadStatusEnum;
    /**
     * Optional training video URL
     * @type {string}
     * @memberof TrainingSessionPayload
     */
    videoUrl?: string;
    /**
     * Custom timestamp for the session start (defaults to now if not provided)
     * @type {Date}
     * @memberof TrainingSessionPayload
     */
    created?: Date;
    /**
     * Project ID associated with this training session
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    readonly project?: number;
    /**
     * Company ID associated with this training session
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    readonly company?: number;
    /**
     * Queue ID that triggered this training session
     * @type {number}
     * @memberof TrainingSessionPayload
     */
    readonly queue?: number;
}

export function TrainingSessionPayloadFromJSON(json: any): TrainingSessionPayload {
    return {
        'testcase': json['testcase'],
        'testcaserevision': !exists(json, 'testcaserevision') ? undefined : json['testcaserevision'],
        'trainingUrl': !exists(json, 'training_url') ? undefined : json['training_url'],
        'customHeaders': !exists(json, 'custom_headers') ? undefined : (json['custom_headers'] as Array<any>).map(QACCustomHeaderFromJSON),
        'triggeredBy': !exists(json, 'triggered_by') ? undefined : json['triggered_by'],
        'timeTaken': !exists(json, 'time_taken') ? undefined : json['time_taken'],
        'tokensConsumed': !exists(json, 'tokens_consumed') ? undefined : json['tokens_consumed'],
        'result': !exists(json, 'result') ? undefined : json['result'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'videoUrl': !exists(json, 'video_url') ? undefined : json['video_url'],
        'created': !exists(json, 'created') ? undefined : new Date(json['created']),
        'project': !exists(json, 'project') ? undefined : json['project'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
    };
}

export function TrainingSessionPayloadToJSON(value?: TrainingSessionPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'testcase': value.testcase,
        'testcaserevision': value.testcaserevision,
        'training_url': value.trainingUrl,
        'custom_headers': value.customHeaders === undefined ? undefined : (value.customHeaders as Array<any>).map(QACCustomHeaderToJSON),
        'triggered_by': value.triggeredBy,
        'time_taken': value.timeTaken,
        'tokens_consumed': value.tokensConsumed,
        'result': value.result,
        'status': value.status,
        'video_url': value.videoUrl,
        'created': value.created === undefined ? undefined : value.created.toISOString(),
    };
}

/**
* @export
* @enum {string}
*/
export enum TrainingSessionPayloadResultEnum {
    Passed = 'passed',
    Failed = 'failed'
}
/**
* @export
* @enum {string}
*/
export enum TrainingSessionPayloadStatusEnum {
    Queued = 'queued',
    Inprogress = 'inprogress',
    Ready = 'ready',
    Failed = 'failed'
}


